import React, { useState, useEffect, useCallback } from 'react';
import api from '../api';
import { useAuth } from '../AuthContext';

const card = { background: 'var(--glass)', backdropFilter: 'var(--blur)', WebkitBackdropFilter: 'var(--blur)', border: '1px solid var(--glass-border)', borderRadius: 12, padding: 20, marginBottom: 16 };
const inp = { padding: '9px 11px', border: '1px solid var(--glass-border)', borderRadius: 8, fontSize: 13 };

export default function Holidays() {
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin';
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState({ name: '', date: '' });

  const load = useCallback(async () => {
    try { const { data } = await api.get('/holidays'); setRows(data); } catch {}
  }, []);
  useEffect(() => { load(); }, [load]);

  const add = async (e) => {
    e.preventDefault();
    if (!form.name || !form.date) return;
    await api.post('/holidays', form);
    setForm({ name: '', date: '' });
    load();
  };
  const del = async (id) => { if (window.confirm('Remove this holiday?')) { await api.delete(`/holidays/${id}`); load(); } };

  const today = new Date().toISOString().slice(0, 10);
  const upcoming = rows.filter(r => r.date >= today);
  const past = rows.filter(r => r.date < today);

  const Row = ({ r, dim }) => (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '11px 4px', borderBottom: '1px solid var(--hairline)', opacity: dim ? 0.55 : 1 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div style={{ width: 44, textAlign: 'center', background: '#ede9fe', borderRadius: 8, padding: '4px 0' }}>
          <div style={{ fontSize: 16, fontWeight: 800, color: '#6d28d9', lineHeight: 1 }}>{new Date(r.date + 'T00:00:00').getDate()}</div>
          <div style={{ fontSize: 10, color: '#7c3aed', textTransform: 'uppercase' }}>{new Date(r.date + 'T00:00:00').toLocaleDateString('en-US', { month: 'short' })}</div>
        </div>
        <div>
          <div style={{ fontWeight: 600, color: 'var(--text)', fontSize: 14 }}>{r.name}</div>
          <div style={{ fontSize: 12, color: 'var(--muted)' }}>{new Date(r.date + 'T00:00:00').toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</div>
        </div>
      </div>
      {isAdmin && <button onClick={() => del(r.id)} style={{ background: 'none', border: 'none', color: '#dc2626', cursor: 'pointer', fontSize: 13 }}>Remove</button>}
    </div>
  );

  return (
    <div style={{ padding: 24, maxWidth: 760, margin: '0 auto' }}>
      <h1 style={{ fontSize: 24, fontWeight: 700, color: 'var(--text)', margin: '0 0 20px' }}>Holidays</h1>

      {isAdmin && (
        <form onSubmit={add} style={{ ...card, display: 'flex', gap: 10, alignItems: 'flex-end', flexWrap: 'wrap' }}>
          <div style={{ flex: 2, minWidth: 180 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text-2)', marginBottom: 5 }}>Holiday name</label>
            <input value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} style={{ ...inp, width: '100%', boxSizing: 'border-box' }} placeholder="e.g. Independence Day" />
          </div>
          <div style={{ flex: 1, minWidth: 140 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text-2)', marginBottom: 5 }}>Date</label>
            <input type="date" value={form.date} onChange={e => setForm(f => ({ ...f, date: e.target.value }))} style={{ ...inp, width: '100%', boxSizing: 'border-box' }} />
          </div>
          <button type="submit" style={{ background: '#4f46e5', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 18px', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>Add</button>
        </form>
      )}

      <div style={card}>
        <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--text)', marginBottom: 8 }}>Upcoming</div>
        {upcoming.length ? upcoming.map(r => <Row key={r.id} r={r} />) : <div style={{ color: 'var(--muted)', fontSize: 13, padding: 16, textAlign: 'center' }}>No upcoming holidays.</div>}
      </div>

      {past.length > 0 && (
        <div style={card}>
          <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--text)', marginBottom: 8 }}>Past</div>
          {past.map(r => <Row key={r.id} r={r} dim />)}
        </div>
      )}
    </div>
  );
}
